import React, { useState } from 'react';
import { 
    Box,
    Button,
} from '@mui/material';

import PermissionGuard from '../../contexts/PermissionContext';

import ExpandedDropDown from '../dropdown/ExpandedDropDown';
import ExpandedSwitch from '../switch/ExpandedSwitch';
import ExpandedTextField from '../display/ExpandedTextField';


export default function PdfConfigPopover(props){

    const {
        config,
        configOptions,
        deleteConfig,
        handleChange
    } = props

    const [darkMode, setDarkMode] = useState(config?.args?.darkmode || true)
    const [reportName, setReportName] = useState(config?.args?.report_name || '')
    const [restrictThumb, setRestrictThumb] = useState(config?.args?.restricted || 'default')
    const [summarized, setSummarized] = useState(config?.args?.summarized || false)

    const [analytics, setAnalytics] = useState(config?.args?.analytics || [])
    const [crew, setCrew] = useState(config?.args?.identity || [])
    const [info, setInfo] = useState(config?.args?.info || [])

    const handleMultiSelectChange = (e, setState) => {
        setState(
            typeof e.target.value === 'string'
            ?
                e.target.value.split(',')
            :
                e.target.value
        )
    }

    const saveArgs = () => {
        handleChange({
            ...config,
            args: {
                ...config?.args,
                analytics: analytics,
                darkmode: darkMode,
                identity: crew,
                info: info,
                report_name: reportName,
                restricted: restrictThumb,
                summarized: summarized
            }
        })
    }


    return (
        <Box
            width={'275px'}
        >
            <Box
                height={'400px'}
                overflow={'auto'}
            >

                <ExpandedTextField
                    label={'Report Name'}
                    onChange={(e) => setReportName(e.target.value)}
                    value={reportName}
                />
                <ExpandedSwitch
                    label={'Dark Mode'}
                    checked={darkMode}
                    onChange={(e) => setDarkMode(e.target.checked)}
                    value={darkMode ? 'Dark Mode' : 'Light Mode'}
                />
                <ExpandedDropDown
                    label={'Required Crew'}
                    options={configOptions.identity}
                    onChange={(e) => handleMultiSelectChange(e, setCrew)}
                    value={crew}
                    multiple
                    fullWidth
                />
                <ExpandedDropDown
                    label={'Required Analytics'}
                    options={configOptions.analytics}
                    onChange={(e) => handleMultiSelectChange(e, setAnalytics)}
                    value={analytics}
                    multiple
                    fullWidth
                />
                <ExpandedDropDown
                    label={'Required Info'}
                    options={configOptions.info}
                    onChange={(e) => handleMultiSelectChange(e, setInfo)}
                    value={info}
                    multiple
                    fullWidth
                />
                <ExpandedDropDown
                    label={'Restrict Thumbnails'}
                    options={configOptions.thumbnails}
                    onChange={(e) => setRestrictThumb(e.target.value)}
                    value={restrictThumb}
                    
                />
                <ExpandedSwitch
                    label={'Summarized'}
                    checked={summarized}
                    onChange={(e) => setSummarized(e.target.checked)}
                    value={summarized ? 'Summarized' : 'Shot Card'}
                />
            </Box>
            <Box
                display={'flex'}
                justifyContent={'space-between'}
            >
                <PermissionGuard permission={['delete:deliverables']}>
                <Button
                    sx={{ color: 'red' }}
                    onClick={deleteConfig}
                >
                    Delete PDF
                </Button>
                </PermissionGuard>
                <Button
                    sx={{ color: 'white' }}
                    onClick={saveArgs}
                >
                    Apply
                </Button>
            </Box>
        </Box>
    )
}